<script setup lang="ts">
import type { HelpParagraph } from "@/store/search/signalDefinitions";

// Explains how to interpret a risk signal and why it matters.
defineProps<{ help: HelpParagraph[] }>();
</script>

<template>
  <div class="signal-help">
    <I18nT
      v-for="paragraph in help"
      :key="paragraph.text"
      :keypath="paragraph.text"
      scope="global"
      tag="p"
    >
      <template #em>
        <em v-if="paragraph.em">{{ $t(paragraph.em) }}</em>
      </template>
    </I18nT>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/mixins/typography";

.signal-help {
  display: flex;
  flex-direction: column;
  text-align: left;

  p {
    @include typography.small("regular");

    margin: 2px 0 0;
    line-height: 1.4;

    em {
      font-style: italic;
    }
  }
}
</style>
